// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a058a227","239":"f770d942","453":"82a6af12","455":"b2ece413"}[chunkId] + ".chunk.js";
};